// ============================================================
// TEAM — Core team and advisory board
// ============================================================
//
// Fields: name, role/title, bio, tw (optional Twitter handle)

export const TEAM_CORE = [
  {
    name: "Dave Hsu, CFA",
    role: "General Partner",
    bio: "Previous investments: Ethena, Monad, Nous Research",
    tw: "DaveHsu",
    substack: "https://idlecycles.substack.com"
  },
];

export const TEAM_ADV = [
  {
    name: "Mike Silagadze",
    title: "Co-Founder & CEO, ether.fi",
    bio: "Co-founder & CEO of ether.fi. Previously founded Top Hat.",
    tw: "MikeSilagadze"
  },
  {
    name: "Jozef Vogel",
    title: "COO, ether.fi",
    bio: "COO of ether.fi. Ex-Aave.",
    tw: "JozefVogel"
  },
  {
    name: "Rok Kopp",
    title: "Co-Founder & CRO, ether.fi",
    bio: "Co-founder & CRO of ether.fi. Ex-Top Hat, Apto.",
    tw: "KoppKnows"
  },
  {
    name: "Charles Mountain",
    title: "Head of Ecosystem, ether.fi",
    bio: "Head of Ecosystem at ether.fi. Ex-Hivemind Capital",
    tw: "Showtime0x"
  },
];
